import type { SvgIconComponent } from "@mui/icons-material";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import { Box } from "@mui/material";

import { CrmObject } from "../../generated/graphql";
import { CRM_COLORS, CRM_OBJECT_COLORS } from "../../lib/crm";

export const CRM_OBJECT_ICONS: Record<CrmObject, SvgIconComponent> = {
  [CrmObject.Account]: ApartmentOutlinedIcon,
  [CrmObject.Opportunity]: WorkOutlineOutlinedIcon,
  [CrmObject.Contact]: ContactPageOutlinedIcon,
  [CrmObject.Lead]: PersonAddAlt1OutlinedIcon,
  [CrmObject.Case]: WorkOutlineOutlinedIcon,
  [CrmObject.Contract]: DescriptionOutlinedIcon,
  [CrmObject.ContractItem]: ReceiptLongOutlinedIcon,
  [CrmObject.Order]: LocalShippingOutlinedIcon,
  [CrmObject.LeadProduct]: ShoppingCartOutlinedIcon,
  [CrmObject.Campaign]: CampaignOutlinedIcon,
  [CrmObject.CampaignMember]: GroupsOutlinedIcon,
};

const TILE_SIZES = { small: 24, medium: 32, large: 40 } as const;

type CrmIconTileProps = { Icon: SvgIconComponent; color: string; size: number };

// A white icon on a coloured square, as Salesforce marks a kind of record.
export const CrmIconTile = ({ Icon, color, size }: CrmIconTileProps) => (
  <Box
    aria-hidden
    sx={{
      display: "flex",
      flex: "none",
      alignItems: "center",
      justifyContent: "center",
      width: size,
      height: size,
      borderRadius: "4px",
      backgroundColor: color,
      color: CRM_COLORS.iconForeground,
    }}
  >
    <Icon sx={{ fontSize: Math.round(size * 0.62) }} />
  </Box>
);

type CrmObjectIconProps = {
  object: CrmObject;
  size?: keyof typeof TILE_SIZES;
};

// The coloured square Salesforce shows for each object type.
export const CrmObjectIcon = ({ object, size = "medium" }: CrmObjectIconProps) => (
  <CrmIconTile Icon={CRM_OBJECT_ICONS[object]} color={CRM_OBJECT_COLORS[object]} size={TILE_SIZES[size]} />
);
